import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

export const translations = {
  en: {
    brand: 'AI Absorption Sandbox',
    appName: 'Enterprise AI Value & Absorption Sandbox',
    heroTitle: 'Value & Absorption Simulator',
    quote: '"THE DEMO CAN WORK. THE TECHNOLOGY CAN WORK. BUT IF BEHAVIOUR, OWNERSHIP AND WORKFLOW DO NOT CHANGE, VALUE DOES NOT SCALE."',
    totalUseCases: 'Total Use Cases',
    fiveLayer: 'Five-Layer Readiness',
    rtl: 'RTL',
    welcomeBack: 'Welcome back',
    signInSub: 'Sign in to the Enterprise AI Value & Absorption Sandbox',
    continueGoogle: 'Continue with Google',
    adminNote: 'Administrator access only. Sign in with your Google account.',
    langToggle: 'العربية',
    // nav
    overview: 'Overview',
    useCases: 'Use Cases',
    readiness: 'Readiness',
    logout: 'Sign out',
    // overview
    portfolioValue: 'Portfolio Annual Value',
    avgAbsorption: 'Avg. Absorption',
    avgValue: 'Avg. Value Score',
    scaled: 'Scaled',
    live: 'Live',
    piloting: 'Piloting',
    backlog: 'Backlog',
    portfolioStatus: 'Portfolio by Status',
    fiveLayerReadiness: 'Five-Layer Readiness Index',
    valueVsAbsorption: 'Value vs. Absorption',
    valueVsAbsorptionSub: 'Each dot is a use case. High value + high absorption = scaled value.',
    byFunction: 'Use Cases by Function',
    // use cases page
    searchPlaceholder: 'Search use cases...',
    allFunctions: 'All Functions',
    allStatuses: 'All Statuses',
    value: 'Value',
    absorption: 'Absorption',
    readinessLabel: 'Readiness',
    owner: 'Owner',
    annualValue: 'Annual Value',
    resultsFound: 'use cases',
    // readiness page
    readinessTitle: 'Five-Layer Readiness Model',
    readinessSub: 'Value scales only when all five layers mature together. A single weak layer caps realised value.',
    layerScore: 'Average score across portfolio',
    weakestLayer: 'Weakest layer',
    strongestLayer: 'Strongest layer',
    close: 'Close',
    // read-aloud
    readAloud: 'Read aloud',
    listen: 'Listen',
    generating: 'Preparing summary…',
    transcript: 'Transcript',
    speed: 'Speed',
    play: 'Play',
    pause: 'Pause',
    resume: 'Resume',
    stop: 'Stop',
    aiSummary: 'AI Spoken Summary',
    ttsUnsupported: 'Voice playback is not supported in this browser. Read the transcript below.',
  },
  ar: {
    brand: 'مختبر استيعاب الذكاء الاصطناعي',
    appName: 'مختبر قيمة واستيعاب الذكاء الاصطناعي للمؤسسات',
    heroTitle: 'محاكي القيمة والاستيعاب',
    quote: '"قد ينجح العرض التوضيحي. وقد تنجح التقنية. لكن إذا لم يتغير السلوك والملكية وسير العمل، فلن تتوسع القيمة."',
    totalUseCases: 'إجمالي حالات الاستخدام',
    fiveLayer: 'الجاهزية الخماسية',
    rtl: 'من اليمين لليسار',
    welcomeBack: 'مرحباً بعودتك',
    signInSub: 'سجّل الدخول إلى مختبر قيمة واستيعاب الذكاء الاصطناعي',
    continueGoogle: 'المتابعة عبر جوجل',
    adminNote: 'الوصول للمسؤولين فقط. سجّل الدخول عبر حساب جوجل.',
    langToggle: 'English',
    overview: 'نظرة عامة',
    useCases: 'حالات الاستخدام',
    readiness: 'الجاهزية',
    logout: 'تسجيل الخروج',
    portfolioValue: 'القيمة السنوية للمحفظة',
    avgAbsorption: 'متوسط الاستيعاب',
    avgValue: 'متوسط درجة القيمة',
    scaled: 'موسّع',
    live: 'مباشر',
    piloting: 'قيد التجربة',
    backlog: 'قائمة الانتظار',
    portfolioStatus: 'المحفظة حسب الحالة',
    fiveLayerReadiness: 'مؤشر الجاهزية الخماسي',
    valueVsAbsorption: 'القيمة مقابل الاستيعاب',
    valueVsAbsorptionSub: 'كل نقطة تمثل حالة استخدام. قيمة عالية + استيعاب عالٍ = قيمة موسّعة.',
    byFunction: 'حالات الاستخدام حسب الوظيفة',
    searchPlaceholder: 'ابحث في حالات الاستخدام...',
    allFunctions: 'كل الوظائف',
    allStatuses: 'كل الحالات',
    value: 'القيمة',
    absorption: 'الاستيعاب',
    readinessLabel: 'الجاهزية',
    owner: 'المالك',
    annualValue: 'القيمة السنوية',
    resultsFound: 'حالة استخدام',
    readinessTitle: 'نموذج الجاهزية الخماسي',
    readinessSub: 'تتوسع القيمة فقط عندما تنضج الطبقات الخمس معاً. طبقة ضعيفة واحدة تحدّ من القيمة المحققة.',
    layerScore: 'متوسط الدرجة عبر المحفظة',
    weakestLayer: 'أضعف طبقة',
    strongestLayer: 'أقوى طبقة',
    close: 'إغلاق',
    readAloud: '\u0627\u0642\u0631\u0623 \u0628\u0635\u0648\u062a \u0639\u0627\u0644\u064d',
    listen: '\u0627\u0633\u062a\u0645\u0627\u0639',
    generating: '\u062c\u0627\u0631\u064d \u062a\u062c\u0647\u064a\u0632 \u0627\u0644\u0645\u0644\u062e\u0635\u2026',
    transcript: '\u0627\u0644\u0646\u0635',
    speed: '\u0627\u0644\u0633\u0631\u0639\u0629',
    play: '\u062a\u0634\u063a\u064a\u0644',
    pause: '\u0625\u064a\u0642\u0627\u0641 \u0645\u0624\u0642\u062a',
    resume: '\u0627\u0633\u062a\u0626\u0646\u0627\u0641',
    stop: '\u0625\u064a\u0642\u0627\u0641',
    aiSummary: '\u0645\u0644\u062e\u0635 \u0635\u0648\u062a\u064a \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a',
    ttsUnsupported: '\u062a\u0634\u063a\u064a\u0644 \u0627\u0644\u0635\u0648\u062a \u063a\u064a\u0631 \u0645\u062f\u0639\u0648\u0645 \u0641\u064a \u0647\u0630\u0627 \u0627\u0644\u0645\u062a\u0635\u0641\u062d. \u0627\u0642\u0631\u0623 \u0627\u0644\u0646\u0635 \u0623\u062f\u0646\u0627\u0647.',
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'en');

  useEffect(() => {
    localStorage.setItem('lang', lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === 'en' ? 'ar' : 'en')), []);
  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);
  const tf = useCallback((obj) => (lang === 'ar' ? obj.ar : obj.en), [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t, tf, isRTL: lang === 'ar' }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
